import React from 'react';

const formatDate = new Intl.DateTimeFormat().format;

export function PlanText({allSubscriptions, activeSubscription}) {
  if (allSubscriptions.length === 0) {
    return <p>This member is not subscribed to any plans.</p>;
  }

  return (
    <div>
      {activeSubscription == null ? (
        <p>This member has no active plan.</p>
      ) : (
        <>
          <p>Active plan: {activeSubscription.membershipPlan.title}</p>
          <p>
            <small>
              Valid from {formatDate(new Date(activeSubscription.startDate))} to{' '}
              {formatDate(new Date(activeSubscription.endDate))}
            </small>
          </p>
        </>
      )}
    </div>
  );
}
